import React from 'react';

import cc from 'classcat';
import Title from './Title';
import Subtitle from './Subtitle';

import classes from './TitleCell.module.scss';

export interface ITitleCell {
    title: string;
    subTitle?: string;
    id?: string;
    userId?: number;
    isEditableTitle?: boolean;
    onTitleEdit?: (value: string) => void;
}

const TitleCell = ({ title, subTitle, id, userId, isEditableTitle, onTitleEdit }: ITitleCell) => {
    return (
        <div className={classes.titleCell}>
            <Title title={title} id={id} userId={userId} isEditableTitle={isEditableTitle} onTitleEdit={onTitleEdit} />
            <Subtitle subTitle={subTitle} id={id} className={cc([{ [classes.subtitleNearEditableTitle]: isEditableTitle }])} />
        </div>
    );
};

export default TitleCell;
